import React from 'react'
import DashboardLayout from '../layouts/DashboardLayout'

const PrivacyPolicy = props => {
    return (
        <DashboardLayout hideAccountDropdown={true} hideSidebar={true} >
        <div>
            <h2>Privacy Policy</h2>
        </div>
        </DashboardLayout>
      
    )
}

export default PrivacyPolicy
